'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.forEachReferenceField = forEachReferenceField;
exports.wrapReferenceField = wrapReferenceField;
exports.unwrapReferenceField = unwrapReferenceField;
exports.wrapAllReferences = wrapAllReferences;
exports.unwrapAllReferences = unwrapAllReferences;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _wixDataWebmethodStructures = require('wix-data-webmethod-structures');

var _lodashClonedeep = require('lodash.clonedeep');

var _lodashClonedeep2 = _interopRequireDefault(_lodashClonedeep);

function forEachReferenceField(schema, callback) {
  if (schema.fields) {
    Object.keys(schema.fields || {}).map(function (field) {
      return [field, schema.fields[field]];
    }).filter(function (field) {
      return field[1].type === 'reference';
    }).map(function (field) {
      return field[0];
    }).forEach(callback);
  }
}

function wrapReferenceField(item, fieldName) {
  if (!(item[fieldName] instanceof _wixDataWebmethodStructures.Ref)) {
    var fieldValue = item[fieldName];

    if (fieldValue === null) {
      item[fieldName] = null;
    } else {
      var bestMatchForReferenceParameter = isObject(fieldValue) ? fieldValue._item || fieldValue.item || fieldValue._id || fieldValue.ref : typeof fieldValue === 'string' ? fieldValue : undefined;

      if (typeof bestMatchForReferenceParameter !== 'undefined') {
        item[fieldName] = new _wixDataWebmethodStructures.Ref(bestMatchForReferenceParameter);
      } else if (typeof fieldValue !== 'undefined') {
        item[fieldName] = fieldValue;
      }
    }
  }
  return item;
}

function unwrapReferenceField(item, fieldName) {
  if (item.hasOwnProperty(fieldName) && item[fieldName]) {

    if (item[fieldName].hasOwnProperty('_id')) {
      item[fieldName] = item[fieldName]._id;
    } else if (item[fieldName].hasOwnProperty('ref')) {
      // Temporary compatibility mode.
      item[fieldName] = item[fieldName].ref;
    }

    // if (isFunction(item[fieldName].toJSON)) {
    //   item[fieldName] = item[fieldName].toJSON()
    // }
    // delete item[fieldName].item
  }

  return item;
}

function wrapAllReferences(schema, item) {
  var resultingItem = (0, _lodashClonedeep2['default'])(item);

  if (!reflessJoinsEnabled()) {
    forEachReferenceField(schema, wrapReferenceField.bind(null, resultingItem));
  }

  return resultingItem;
}

function unwrapAllReferences(schema, item) {
  var resultingItem = (0, _lodashClonedeep2['default'])(item);

  forEachReferenceField(schema, unwrapReferenceField.bind(null, resultingItem));

  return resultingItem;
}

function isObject(param) {
  return typeof param === 'object';
}

function reflessJoinsEnabled() {
  //return process && process.env && process.env.NEW_JOINS
  return true;
}